import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Image, Form } from "react-bootstrap";
import { IoCloseOutline } from "react-icons/io5";
import { getToken } from "../../../../utils/auth";
import { useNavigate } from "react-router-dom"; // Assuming you're using react-router-dom for navigation
import toast, { Toaster } from "react-hot-toast";

const SearchComponent = ({ isMobile = false, isRTL = false  }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [dropdown, setDropdown] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const dropdownRef = useRef(null);
  const navigate = useNavigate(); // Hook for navigation

  const handleChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const closeDropdown = () => {
    setDropdown(false);
    setSearchQuery(""); // Clear the search query when closing the dropdown
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setDropdown(true);
    if (searchQuery.trim() !== "") {
      handleSearch(searchQuery);
    }
  };

  const handleNavigatePost = (post) => {
  if (!post?.redirectLink) {
    console.error("Post redirect link is missing.");
    return;
  }
  setDropdown(false);
  window.open(post.redirectLink, "_blank");
  setSearchQuery("");
  closeDropdown();
};

const handleNavigateEvent = (event) => {
  if (!event?.redirectLink) {
    toast.error("Event redirect link is missing.");
    return;
  }
  setDropdown(false);
  window.open(event.redirectLink, "_blank");
  setSearchQuery("");
  closeDropdown();
};

  const handleSearch = async (query) => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user/search?keyword=${query}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data.data;
      let results = [];
      // Check for results in each category and add them
      if (data.people?.length > 0) {
        results.push({ category: "People", items: data.people });
      }
      if (data.criticalD?.length > 0) {
        results.push({ category: "Critical-D", items: data.criticalD });
      }
      if (data.lostAndFound?.length > 0) {
        results.push({ category: "Tracked Found", items: data.lostAndFound });
      }
      if (data.socialNet?.length > 0) {
        results.push({ category: "QR Hero", items: data.socialNet });
      }
          if (data.posts?.length > 0) {
      results.push({ category: "Posts", items: data.posts });
    }
    if (data.events?.length > 0) {
      results.push({ category: "Events", items: data.events });
    }

      setSearchResults(results);
    } catch (error) {
      console.error("Failed Fetching Search Detail", error);
    }
  };

  const handleNavigateProfile = (userdata) => {
    if (!userdata?.username) {
      console.error("User data is missing or invalid.");
      return;
    }

    setDropdown(false);
    const countryCode = encodeURIComponent(userdata?.country?.toLowerCase() || "country");
    const username = encodeURIComponent(userdata?.username);

    // Navigate to the profile page
    navigate(`/profileview/${countryCode}/${username}`);
    
    // Clear the search query after navigation
    setSearchQuery("");
    closeDropdown();
  };

  const handleNavigateCriticalD = (data) => {
    if (!data?.staticContent) {
      console.error("Critical data is missing or invalid.");
      return;
    }

    setDropdown(false);

    const baseUrl = `${data?.staticContent}?isSearched=true`;

    // Open a new tab with the Critical-D content
    window.open(baseUrl, "_blank");

    // Clear the search query after navigating
    setSearchQuery("");
    closeDropdown();
  };

  const handleNavigateLost = (data) => {
    if (!data?.staticContent) {
      console.error("Lost data is missing or invalid.");
      return;
    }

    setDropdown(false);

    const baseUrl = `${data?.staticContent}?isSearched=true`;

    // Open a new tab with the Lost & Found content
    window.open(baseUrl, "_blank");

    // Clear the search query after navigating
    setSearchQuery("");
    closeDropdown();
  };

  const handleNavigateSocialNet = (data) => {
    if (!data?.staticContent) {
      console.error("Social Net data is missing or invalid.");
      return;
    }

    setDropdown(false);

    const baseUrl = `${data?.staticContent}?isSearched=true`;

    // Open a new tab with the QR Hero (Social Net) content
    window.open(baseUrl, "_blank");

    // Clear the search query after navigating
    setSearchQuery("");
    closeDropdown();
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchQuery.trim() !== "") {
        handleSearch(searchQuery);
      } else {
        setSearchResults([]);
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [searchQuery]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closeDropdown();
      }
    };

    if (dropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdown]);

return (
  <div dir={isRTL ? "rtl" : "ltr"} className="iq-search-bar device-search" style={{
    width: isMobile ? "100%" : "auto"
  }}>
    <Toaster position="top-right" reverseOrder={false} />

    <form
      action="#"
      style={{ display: "flex", border: "1px solid #d3d3d3", borderRadius: "5px" }}
      className="searchbox"
      onSubmit={handleSubmit}
    >
      <Form.Control
        type="text"
        style={{ borderRadius: "0", borderTopRightRadius: "5px", borderBottomRightRadius: "4px", padding:"5px",paddingRight: isRTL ? "5px" : "40px", // ⭐ space for icon
  paddingLeft: isRTL ? "40px" : "5px", }}
        value={searchQuery}
        onChange={handleChange}
        className={`iq-search-bar device-search ${isMobile ? 'd-lg-none d-block' : 'd-none d-lg-block'}`}
        // className="text search-input form-control bg-soft-primary d-none d-lg-block"
        placeholder="Search..."
      />

      {/* Search / Close Icon */}
      {dropdown && searchResults.length > 0 ? (
        <span
          onClick={closeDropdown}
          style={{ position: "absolute", [isRTL ? "left" : "right"]: "10px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", fontSize: "18px", color: "#999" }}
        >
          <IoCloseOutline />
        </span>
      ) : (
        <span
          onClick={handleSubmit}
          style={{ position: "absolute", [isRTL ? "left" : "right"]: "10px",  top: "50%", transform: "translateY(-50%)", cursor: "pointer", fontSize: "18px", color: "#999" }}
        >
          <span className={`material-symbols-outlined ${isMobile ? 'd-flex' : 'd-none d-lg-flex'}`}>search</span>
        </span>
      )}

      {/* Dropdown */}
      {dropdown && (
        <div
          ref={dropdownRef}
          style={{
            display: "flex",
            flexDirection: "column",
            width: isMobile ? "100%" : "150%",
            // width: "150%",
            maxHeight: "300px",
            background: "#fff",
            border: "1px solid #d3d3d3",
            borderTop: "none",
            position: "absolute",
            marginLeft: isMobile ? "0" : "-25%",
            // marginLeft: "-25%",
            borderEndStartRadius: "10px",
            borderEndEndRadius: "10px",
            marginTop: "40px",
            overflowY: "auto",
          }}
        >
          {searchResults.length > 0 ? (
            searchResults.map((categoryData, categoryIndex) => {
              const category = categoryData.category.toLowerCase();

              return (
                <div key={categoryIndex}>
                  <h6 style={{ padding: "10px 15px", background: "#f8f8f8" }}>
                    {categoryData.category}
                  </h6>

                  {categoryData.items.map((data, index) => (
                    <div className="d-flex align-items-center search-hover py-2 px-3" key={index}>
                      
                      {/* Image */}
                      <div className="flex-shrink-0">
                        <Image
                          className="align-self-center img-fluid rounded"
                          src={
                            category === "events"
                              ? data.image || "/profile.png"
                              : category === "posts"
                              ? data.photos?.[0] || "/profile.png"
                              : data?.profileImageLink || "/profile.png"
                          }
                          alt={data.title || "Image"}
                          loading="lazy"
                          style={{ width: "50px", height: "50px", objectFit: "cover" }}
                        />
                      </div>

                      {/* Title / Description */}
                      <div className="d-flex flex-column ms-3 flex-grow-1">
                        {category === "events" && <div className="h6 mb-0">{data.title}</div>}
                        {category === "posts" && (
                          <div style={{ fontSize: "0.85rem", color: "#333" }}>
                            {data.description
                              ? data.description.length > 50
                                ? data.description.substring(0, 50) + "..."
                                : data.description
                              : "No description"}
                          </div>
                        )}
                        {["people", "critical-d", "tracked found", "qr hero"].includes(category) && (
                          <div className="h5 mb-0">{data?.firstName || data?.qrc_UID}</div>
                        )}
                      </div>

                      {/* Button */}
                      <div className="d-flex align-items-center ms-auto">
                        {category === "people" && (
                          <button className="btn btn-primary d-block w-100 mt-0" onClick={() => handleNavigateProfile(data)}>
                            View Profile
                          </button>
                        )}
                        {category === "critical-d" && (
                          <button className="btn btn-primary d-block w-100 mt-0" style={{ whiteSpace: "nowrap" }} onClick={() => handleNavigateCriticalD(data)}>
                            View Critical-D
                          </button>
                        )}
                        {category === "tracked found" && (
                          <button className="btn btn-primary d-block w-100 mt-0" style={{ whiteSpace: "nowrap" }} onClick={() => handleNavigateLost(data)}>
                            View Tracked Found
                          </button>
                        )}
                        {category === "qr hero" && (
                          <button className="btn btn-primary d-block w-100 mt-0" style={{ whiteSpace: "nowrap" }} onClick={() => handleNavigateSocialNet(data)}>
                            View QR Hero
                          </button>
                        )}
                        {category === "posts" && (
                          <button className="btn btn-primary d-block w-100 mt-0" style={{ whiteSpace: "nowrap" }} onClick={() => handleNavigatePost(data)}>
                            View Post
                          </button>
                        )}
                        {category === "events" && (
                          <button className="btn btn-primary d-block w-100 mt-0" style={{ whiteSpace: "nowrap" }} onClick={() => handleNavigateEvent(data)}>
                            View Event
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })
          ) : (
            <div className="p-3">No results found</div>
          )}
        </div>
      )}
    </form>
  </div>
);


};

export default SearchComponent;
